import type { Footer } from './footer';

export const footerData: Footer = {
  aceFooterLogo: [
    {
      typeHandle: 'logo',
      logoLink: 'https://insurance.aceable.com/',
      logoImage: [
        {
          url: 'https://xgrit-ecom.imgix.net/v3_images/transforms/_350x89_crop_center-center_none/ace_ins_logo.svg?v=1730836120&auto=compress,format',
          altText: 'Aceable Insurance Logo (Footer)',
        },
      ],
    },
  ],
  aceGeneralLinkGroup: [
    {
      typeHandle: 'link',
      linkUrl: '/support/',
      linkText: 'Help Center',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: '/resources/',
      linkText: 'Blog',
      newTab: false,
      nofollow: false,
    },
  ],
  aceVerticalLinkGroup: [
    {
      typeHandle: 'link',
      linkUrl: 'https://www.aceable.com/driving/',
      linkText: 'Driving',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://www.aceableagent.com/',
      linkText: 'Real Estate',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://insurance.aceable.com/',
      linkText: 'Insurance',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://www.mortgage.aceable.com/',
      linkText: 'Mortgage',
      newTab: false,
      nofollow: false,
    },
  ],
  aceSocialLinkGroup: [
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://www.instagram.com/aceableinsurance/',
      linkText: 'Instagram',
      newTab: true,
      nofollow: false,
      icon: 'instagram',
    },
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://www.tiktok.com/@aceable.insurance',
      linkText: 'TikTok',
      newTab: true,
      nofollow: false,
      icon: 'tiktok',
    },
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://www.facebook.com/profile.php?id=61569568198073',
      linkText: 'Facebook',
      newTab: true,
      nofollow: false,
      icon: 'facebook-square',
    },
  ],
  bottomLinkGroup: [
    {
      typeHandle: 'link',
      linkText: 'Privacy Policy',
      linkUrl: 'https://insurance.aceable.com/privacy-policy/',
      nofollow: false,
      newTab: false,
    },
    {
      typeHandle: 'link',
      linkText: 'Terms & Conditions',
      linkUrl: 'https://insurance.aceable.com/terms-and-conditions/',
      nofollow: false,
      newTab: false,
    },
  ],
  aceShareGroup: [
    {
      label: 'Partner with Us',
      link: '/insurance-partnerships/',
    },
    {
      label: 'Refer a Friend',
      link: '/referral/invite/',
    },
  ],
  aceShowHideFooterNav: true,
  emailCapture: [],
};
